<div class="d-flex flex-column w-100 mt-4">
	<div class="p-fluid mb-3 text-center">
		<p-selectButton
			[options]="orderTypes"
			[(ngModel)]="orderTypeSelected"
			optionLabel="displayName"
			name="orderTypeselectButton"
			[style]="{ 'flex-direction': 'column' }"
			(onChange)="orderTypeSelectedChange.emit(orderTypeSelected)"
		>
			<ng-template let-item>
				<div class="d-flex w-100">
					<div class="mx-auto display-4">
						{{ item.displayName }}
					</div>
				</div>
			</ng-template>
		</p-selectButton>
	</div>
</div>
